import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';


const Home = () => (
    <Fragment>
        <Helmet><title>instructions</title></Helmet>
        <div id="home">
            
            <section className='main-home'>
               
                <div className='logo-container'>
                </div>
                <h1>eduraw</h1>
                <div className="play-btn-container">
                    <ul style={{listStyleType: "none" }}>
                        <li>
                            <Link className='play-btn' to="/play/teampicker">Start Game</Link>
                        </li>
                    </ul>
                </div>
                <div className="auth-btn-container">
                    <Link className='dash-btn' to="/Dashboard">Dashboard</Link>
                    <Link className='project-btn' to="/Project">Project</Link>
                    <Link className='project-btn' to="/Manual">How to play</Link>

                </div>

                
            </section> 

            
        </div>  
      

    </Fragment>
    
);

export default Home;
